import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { Box, Button, Container, Tab, Tabs, Typography } from '@mui/material'
import { withStyles } from '@mui/styles'
import { reportDetailedStyles } from './report-detailed.styles'
import { JobsTable, useJobsContext } from '../../../../features/jobs'
import { ReportTable } from '../../../../features/jobs/components/report-table/report-table.component'
import { useNavigate, useParams } from 'react-router-dom'
import { ReportDetailedComponent } from '../../../../features/jobs/components/detailed/report-detailed.component'

export const ReportDetailedPage = withStyles(reportDetailedStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const { getReportById } = useJobsContext()
  const navigate = useNavigate()
  const { executionId } = useParams()

  useEffect(() => {
    getReportById(executionId)
  }, [executionId])

  return (
    <Container className={classes.container} maxWidth={false}>
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.jobs.dashboard.title' })}
        </Typography>
      </Box>
      <Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
            {formatMessage({ id: 'global.return' })}
          </Button>
        </Box>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <ReportDetailedComponent />
        </Box>
      </Box>
    </Container>
  )
})
